export const getFormApiHost = () => {
    const key = window.location.host.split('.')[0].toLocaleLowerCase();
    switch (key) {
        case 'forms-qa':
            return 'https://forms-qa.azurewebsites.net/api';
        default:
            //return 'https://forms-365.azurewebsites.net/api';
            return 'https://api.sbforms.net/api';
    }

};
export const getSiteGovernUrl = () => {

    const key = window.location.host.split('.')[0].toLocaleLowerCase();
    switch (key) {
        case 'sbdemo':
            return 'https://sitegoverndemo.schoolbundle365.com/';
        case '7oaks':
            return 'https://sitegovern.7oaks.org/';
        case 'sd35':
            return 'https://sitegovern.sd35.bc.ca/';
        case 'spsd':
            return 'https://sitegovern.spsd.sk.ca/';
        case 'sd72':
            return 'https://sitegovern.sd72.bc.ca/';
        case 'sd73':
            return 'https://sitegovern.sd73.bc.ca/';
        case 'sd43':
            return 'https://sitegovern.sd43.bc.ca/';
        case 'prsd':
            return 'https://sitegovern.prsd.ab.ca/';
        case 'dsb1':
            return 'https://sitegovern.dsb1.ca/';
        case 'wsd':
            return 'https://sitegovern.winnipegsd.ca/';
        default:
            return 'https://sitegovern.sbqa01.com/';
    }
};
export const getClientInfo = () => {

    // try {
    //     console.log('[import.meta]', import.meta);
    //     console.log('[import.meta.env]', import.meta.env);
    // }
    // catch (e) {
    //     console.error(e);
    // }

    const key = window.location.host.split('.')[0].toLocaleLowerCase();
    switch (key) {
        case 'sbdemo':
            // return {
            //     clientId: '813bb564-6eb2-4eda-bb64-92994f480e09',
            //     authority: 'https://login.microsoftonline.com/ac9bc8a3-592e-4cbe-a0e3-8941048741e2'
            // };
            return {
                clientId: '242e801b-36b5-4c7e-83b5-efa0f7d8ba2c',
                authority: 'https://login.microsoftonline.com/6553fd06-ca9f-49ec-af58-366341d3c54f'
            };
        case '7oaks':
            return {
                clientId: '4ca68d24-da54-4507-b9e9-6e827f2f302b',
                authority: 'https://login.microsoftonline.com/6955d5b7-8b25-4d98-a4e3-e16804e1d9fa'
            };
        case 'sd35':
            return {
                clientId: '5e7b7c68-6a66-47ec-9187-fa63dfbb08b4',
                authority: 'https://login.microsoftonline.com/fcabfaae-f80a-4f74-b6a7-ba15c2a4bb24'
            };
        case 'spsd':
            return {
                clientId: '5c3e152a-1ecb-4006-981b-b8d9bb7381ce',
                authority: 'https://login.microsoftonline.com/771c58fc-27f7-4fa4-aad5-8299109e3854'
            };
        case 'sd72':
            return {
                clientId: 'ba46f930-6516-438f-a86c-f8aaad2c9edf',
                authority: 'https://login.microsoftonline.com/3c39a3a9-82d4-4858-8ea4-5f9ae56f5386'
            };
        case 'sd73':
            return {
                clientId: '48d2a7c3-002c-4cdc-a765-a4ba1ac47f85',
                authority: 'https://login.microsoftonline.com/3ed92586-8845-45ca-b5ab-196485be6696'
            };
        case 'sd43':
            return {
                clientId: '82ea013c-e356-46f6-ab06-2874765bab92',
                authority: 'https://login.microsoftonline.com/d9658cef-0292-4252-9925-6442de24a44b'
            };
        // case 'prsd':
        //     return {
        //         clientId: 'bbb88d0f-bf14-4144-97f2-fffb9d2eb3e1',
        //         authority: 'https://login.microsoftonline.com/549138e9-3c2a-458a-82e0-8a1c10e55a7b'
        //     };
        case 'dsb1':
            return {
                clientId: 'c0bd1d4d-bdf3-4cdc-ba9d-3d349dcbe201',
                authority: 'https://login.microsoftonline.com/99567a4e-5bdf-4cfc-9c7c-53e4540eb57a'
            };
        case 'wsd':
            return {
                clientId: 'dc2483ea-abf8-44a9-a433-599fa1ae5327',
                authority: 'https://login.microsoftonline.com/b5d5bd97-814e-4c8e-9939-c3bb706cbca7'
            };
        default:
            return {
                clientId: '17ff9d82-c5ce-4aa1-a56d-163188755dc0',
                authority: 'https://login.microsoftonline.com/549138e9-3c2a-458a-82e0-8a1c10e55a7b'
            };
    }
};
export const getCustomerTypes = () => {
    
    const key = window.location.host.split('.')[0].toLocaleLowerCase();
    switch (key) {
        case 'forms-qa':
        case '7oaks':
            return ['pricetotal', 'redirect_url_do_not_change'];
        case 'sbdemo':
            return ['pricetotal'];
        default:
            return [];
    }
};
export const getGoogleClientId = () => {
    
    const key = window.location.host;
    switch (key) {       
        // case 'forms-qa.sitegovern.com':
        // case 'forms-qa.azurewebsites.net':
        //     return '927740018254-1efcl3r3n5mvpe7o87dj6mg01uudv2dg.apps.googleusercontent.com';
        case 'prsd.sbforms.net':
            // return '481853263394-iipl15q3l4u9pi8fumafbd7a9oas4bt7.apps.googleusercontent.com';
            // return '578851077064-ijhdtm7qc8v8jmtmml119i2dv64fe273.apps.googleusercontent.com';
            return '614062864602-55tto5o9ca4ugqsi856t6rqh0e5oahca.apps.googleusercontent.com';
        default:
            return '';
    }
}